import React from 'react';

const InvalidFieldsForEnquiryBanner: React.FunctionComponent<{
  invalidITems: string[];
  onAction?: () => void;
}> = (props) => {
  const message = props.invalidITems.join(', ');

  return !!props.invalidITems?.length ? (
    <div className="bg-warning py-1 font-weight-semibold">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-12 text-white font-sm d-flex align-items-center">
            <i className="icon-box bg-orange-light text-white rounded-circle icon-receipt mr-2 d-inline-flex justify-content-center align-items-center"></i>
            <div className="px-1">
              The following information is missing in the customer profile for
              converting Lead to Enquiry. Please update
            </div>
            <span
              onClick={() => {
                props?.onAction?.();
              }}
              className="d-inline-block px-2 bg-white text-dark rounded-pill py-1 cursor-pointer"
            >
              {message}
            </span>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default InvalidFieldsForEnquiryBanner;
